import React from 'react';
import { useTranslation } from 'react-i18next';

interface CategoryFilterProps {
  categories: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ categories, selected, onChange }) => {
  const { t } = useTranslation();
  const handleToggle = (cat: string) => {
    if (selected.includes(cat)) {
      onChange(selected.filter(c => c !== cat));
    } else {
      onChange([...selected, cat]);
    }
  };
  return (
    <div className="flex flex-wrap gap-2 mb-8 justify-center">
      {categories.map((cat) => (
        <button
          key={cat}
          className={`px-4 py-2 rounded-lg border font-medium transition-all ${selected.includes(cat) ? 'bg-blue-600 text-white' : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50'}`}
          onClick={() => handleToggle(cat)}
          type="button"
        >
          {t(`products.categories.${cat}`, cat.charAt(0).toUpperCase() + cat.slice(1))}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter; 